import React from "react";

const Projectdatahome = [
  {
    title: "Cathedral of barisa",
    category: "Architecture",
    img: "../Asset/project-2.jpg",
  },
  {
    title: "Cathedral of barisa",
    category: "Architecture",
    img: "../Asset/project-3.jpg",
  },
  {
    title: "Cathedral of barisa",
    category: "Architecture",
    img: "../Asset/project-4.jpg",
  },
  {
    title: "Cathedral of barisa",
    category: "Architecture",
    img: "../Asset/project-5.jpg",
  },
  {
    title: "Cathedral of barisa",
    category: "Architecture",
    img: "../Asset/project-6.jpg",
  },
];
const testimonialdata = [
  {
    name: "Ferdrick",
    img: "../Asset/testi-1.jpg",
    para: `Certainly! If you provide me with some information or context, I'd be happy to help you craft a small testimonial. For instance, let me know what product, 
        service, or experience you'd like the testimonial to be about`,
    position: "Director",
  },
  {
    name: "Ferdrick",
    img: "../Asset/testi-2.jpg",
    para: `Certainly! If you provide me with some information or context, I'd be happy to help you craft a small testimonial. For instance, let me know what product, 
        service, or experience you'd like the testimonial to be about`,
    position: "Director",
  },
  {
    name: "Ferdrick",
    img: "../Asset/testi-3.jpg",
    para: `Certainly! If you provide me with some information or context, I'd be happy to help you craft a small testimonial. For instance, let me know what product, 
        service, or experience you'd like the testimonial to be about`,
    position: "Director",
  },
  {
    name: "Ferdrick",
    img: "../Asset/testi-2.jpg",
    para: `Certainly! If you provide me with some information or context, I'd be happy to help you craft a small testimonial. For instance, let me know what product, 
        service, or experience you'd like the testimonial to be about`,
    position: "Director",
  },
];
let InteriorHouse = [
  {
    img: "../Asset/hotel.png",
    title: "Bedroom",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/bath.png",
    title: "BathRoom",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/kitchen.png",
    title: "Kitchen",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/interior-design.png",
    title: "Living Room",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/game-controller.png",
    title: "Gaming Room",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/staircase.png",
    title: "Home Office setup",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
];
let InteriorCommercial = [
  {
    img: "../Asset/workplace.png",
    title: "Office",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/game-controller.png",
    title: "Enterainment area",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/interior-design.png",
    title: "Individual Office",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },

  {
    img: "../Asset/staircase.png",
    title: "Entire Office setup",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/food.png",
    title: "Restarunt",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
  {
    img: "../Asset/kitchen.png",
    title: "Office Patry",
    para: "We offer a fully integrated service that complements the architectural concept, we ensure all projects.",
  },
];
let interiorRenovation = {
  service: [
    {
      id:1,
      img: "../Asset/BedRoom1.webp",
      icon1: "../Asset/agreementclr.png",
      icon2: "../Asset/agreement.png",
      category: "Open Floor Plan",
      content:
        "Knocking down walls to create an open floor plan can make a space feel larger and more airy.",
    },
    {
        id:2,
      img: "../Asset/flooringInterior.jpeg",
      category: "Flooring Replacement",
      icon1: "../Asset/interior-designclr.png",
      icon2: "../Asset/agreement.png",
      content:
        "Installing new flooring can transform the look and feel of a space. Consider options such as hardwood, laminate, tile.",
    },
    {
        id:3,
      img: "../Asset/hivacinterior.jpg",
      category: "HVAC System Upgrade",
      icon1: "../Asset/houseclr.png",
      icon2: "../Asset/house.png",
      content:
        "Consider upgrading your heating, ventilation, and air conditioning (HVAC) system for improved comfort and energy efficiency.",
    },
    {
      id:4,
      img: "../Asset/Smarthome.jpeg",
      category: "Smart Home Integration",
      icon1: "../Asset/staircaseclr.png",
      icon2: "../Asset/staircase.png",
      content:
        "Incorporate smart home technology into your renovation plans, such as smart lighting, thermostats, security cameras, and voice-controlled assistants. ",
    },
    {
      id:5,
      img: "../Asset/kitchen1.webp",
      icon1: "../Asset/houseclr.png",
      icon2: "../Asset/house.png",
      category: "Kitchen Remodeling",
      content: `The kitchen is often the heart of the home, so remodeling it can have a significant impact.`,
    },
  ],
};
let exteriorRenovation = {
    service: [
        {
            id: 1,
            icon1: "../Asset/agreementclr.png",
            icon2: "../Asset/agreement.png",
          img: "../Asset/landscaping2.jpg",
          category: "Landscaping",
          content:
            "This may include planting trees, shrubs, flowers, walkways and retaining walls.",
        },
        {
            id: 2,
            icon1: "../Asset/interior-designclr.png",
            icon2: "../Asset/interior-design.png",
          img: "../Asset/PaintingBanner.webp",
          category: "Painting",
          content:
            "Refreshing the exterior paint can significantly enhance the appearance of an House",
        },
        {
            id: 3,
            icon1: "../Asset/agreementclr.png",
            icon2: "../Asset/agreement.png",
          img: "../Asset/glassWindowInterior.jpeg",
          category: "Door and Window polish",
          content:
            "Upgrading windows and doors can enhance energy efficiency, security, and curb appeal.",
        },
        {
            id: 4,
            icon1: "../Asset/staircaseclr.png",
            icon2: "../Asset/staircase.png",
          img: "../Asset/roofingexterior.jpeg",
          category: "Roofing",
          content:
            "Repairing or replacing the roof can improve the overall durability and weather resistance of the building. ",
        },
        {
            id: 5,
            icon1: "../Asset/interior-designclr.png",
            icon2: "../Asset/interior-design.png",
          img: "../Asset/Lightingexterior.jpeg",
          category: "Exterior Lighting",
          content: `Installing outdoor lighting can improve safety and security while also highlighting architectural features.`,
        },
      ],
};
let filterationdata = {
  price: ["1L-20L", "20L-50L", "50L-1C", "1C-2C","above 2C"],
  location: ["Koramangala", "BTM Layout", "Whitefield", "JP Nagar"],
};
export {
  Projectdatahome,
  testimonialdata,
  interiorRenovation,
  exteriorRenovation,
  InteriorCommercial,
  InteriorHouse,
  filterationdata,
};
